import { v4 } from "uuid";

export default function generateguid(){
    return v4();
}